import { takeLatest, put, call } from 'redux-saga/effects';
import type { SagaReturnType } from 'redux-saga/effects';
import { laborHoursConstant } from 'src/redux/actions/constant';
import laborHoursService from 'src/services/apiServices/laborHoursService/laborHoursService';

function* getBuildingsOverview(action: any): SagaReturnType<any> {
  try {
    yield put({ type: laborHoursConstant.GET_BUILDINGS_OVERVIEW_LOADER });
    const response = yield call(laborHoursService.getBuildingsOverview, action.payload);
    if (response?.status === 200) {
      yield put({
        type: laborHoursConstant.GET_BUILDINGS_OVERVIEW_SUCCESS,
        payload: response.data,
      });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: laborHoursConstant.GET_BUILDINGS_OVERVIEW_FAILURE, payload: error });
  }
}

function* getBuildingsOverviewSaga() {
  // takeLatest — paging between pay periods fires back-to-back requests and only the
  // most recent period's overview should land.
  yield takeLatest(laborHoursConstant.GET_BUILDINGS_OVERVIEW_REQUEST, getBuildingsOverview);
}

export default getBuildingsOverviewSaga;
